import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert, UncontrolledTooltip, Table, Spinner, NavLink } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import Session from '../auth/Session';
import { FaSort } from 'react-icons/fa'
import utilities from '../util/utilities';
import { Typeahead } from 'react-bootstrap-typeahead';

//Warm Gray - #5C5C5C
//Orange - #F26230 #FFFFFF
//Light Gray - #DDDDDD
//Almost Black - #373737
//backgroundColor: '#F26230', color: '#FFFFFF'

export class ActiveLeases extends Component {
    static displayName = ActiveLeases.name;

    constructor(props) {
        super(props);
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const isSearch = params.get('search');
        const active = params.get('active');
        const all = params.get('all');

        this.state = {
            clientOptions: [],
            client: null,
            clientText: null,
            search: null,
            candidates: [],
            isAdmin: false,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100000,
            numberOfPages: 0,
            testType: 'Selection',
            testLevel: 'MA',
            searchTerms: {},
            fromSearch: isSearch,
            fromActive: active,
            fromAll: all,
            searchOptions: {}
        };
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async componentDidMount() {
        var _token = Session.getToken();
        //Default For reports
        this.setState({ searchOptions: { sstatus: 1 } });
        if (this.state.fromSearch === "1") {
            var data = JSON.parse(localStorage.getItem('searchOptions'));
            this.setState({ searchOptions: data });
            this.SearchLeases(data);
        } else if (this.state.fromActive) {
            this.GetActiveLeases(this.state.fromActive);

        } else if (this.state.fromAll === "1") {
            this.SearchLeases({});
            this.setState({ searchOptions: {} });
        } else {
            localStorage.setItem('searchOptions', JSON.stringify(this.state.searchOptions));
            this.GetActiveLeases("1");
        }
        //var data = [{ sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 1 },
        //    { sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 0 }];
        //this.setState({ candidates: data });
    }


    //For Pageing!
    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.candidates.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    async handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    async handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.candidates.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.candidates.length / pageSize) })
        }
    }

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.candidates;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            valA = valA.toString(); //How do we fix?
            valB = valB.toString(); //How do we fix?
            return valA.localeCompare(valB);
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            candidates: data,
            sort: {
                column,
                direction
            }
        })
    }
    handleSortInt(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.candidates;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            //return valA.localeCompare(valB);
            if (valA < valB) {
                return -1;
            } else if (valA > valB) {
                return 1;
            } else {
                return 0;
            }
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            candidates: data,
            sort: {
                column,
                direction
            }
        })
    }
    render() {

        // Logic for displaying candidates
        const indexOfLastItem = this.state.currentPage * this.state.itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - this.state.itemsPerPage;
        const currentItems = this.state.candidates.slice(indexOfFirstItem, indexOfLastItem);

        const renderItems = currentItems.map((candidate, i) => {
            return (
                <tr key={i}>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                        <NavLink className="noNavLink"
                            tag={Link}
                            to={'/Lease/LeaseDetails-Summary?id=' + candidate.sd_id}
                        >
                            view
                        </NavLink>
                    </td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{candidate.sd_num}</td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{candidate.sd_region}</td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{candidate.sd_building}</td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{candidate.sd_address}</td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{candidate.sd_city}</td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{candidate.sd_state}</td>
                    <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{candidate.sd_sqft != null ? candidate.sd_sqft.toLocaleString() : ''}</td>
                    <td style={candidate.sd_status === 1 ? { backgroundColor: '#F26230', color: '#FFFFFF' } : { backgroundColor: '#DDDDDD', color: '#000000' }}>{candidate.sd_status === 1 ? 'Open' : 'Closed'}</td>
                </tr>
            )
        });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.state.candidates.length / this.state.itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <option value={number}>{number}</option>
            );
        });

        return (
            <div>
                <Container>


                    <Row>
                        <Col>
                            <h3>Leases</h3>
                        </Col>
                    </Row>
                    <Row>

                        <Col style={{ textAlign: 'center' }}>
                            <div>
                                <Button
                                    color='primary'
                                    onClick={() => this.GetReport("Lease Administration Report")}
                                    style={this.state.width < utilities.dimensions.LG ? { flex: '1', marginTop: '20px', whiteSpace: 'nowrap', backgroundColor: '#F26230', color: '#FFFFFF' } : { flex: '1', whiteSpace: 'nowrap', backgroundColor: '#F26230', color: '#FFFFFF' }}
                                    disabled={this.state.loadingDocument ? true : false}
                                >
                                    Lease Administration Report
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.GetReport("Critical Dates Report")}
                                    style={this.state.width < utilities.dimensions.LG ? { flex: '1', marginTop: '20px', marginLeft: '20px', whiteSpace: 'nowrap', backgroundColor: '#F26230', color: '#FFFFFF' } : { flex: '1', marginLeft: '20px', whiteSpace: 'nowrap', backgroundColor: '#F26230', color: '#FFFFFF' }}
                                    disabled={this.state.loadingDocument ? true : false}
                                >
                                    Critical Dates Report
                                </Button>
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: '20px' }}>
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th className="g-light-gray-c">

                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c">
                                            #
                                            <FaSort
                                                color={this.state.sort.column === 'sd_num' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSortInt('sd_num')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c">
                                            Type
                                            <FaSort
                                                color={this.state.sort.column === 'sd_region' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('sd_region')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c">
                                            Building
                                            <FaSort
                                                color={this.state.sort.column === 'sd_building' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('sd_building')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c">
                                            Address
                                            <FaSort
                                                color={this.state.sort.column === 'sd_address' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('sd_address')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c">
                                            City
                                            <FaSort
                                                color={this.state.sort.column === 'sd_city' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('sd_city')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c">
                                            State
                                            <FaSort
                                                color={this.state.sort.column === 'sd_state' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('sd_state')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c">
                                            SQFT
                                            <FaSort
                                                color={this.state.sort.column === 'sd_sqft' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSortInt('sd_sqft')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c">
                                            Status
                                            <FaSort
                                                color={this.state.sort.column === 'sd_status' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSortInt('sd_status')}
                                                className='sort-button'
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.loading === true && this.state.loadingDocument === false ? (
                                        <>
                                            <tr>
                                                <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <Spinner color="primary" children='' />
                                                </td>
                                            </tr>
                                        </>


                                    ) : (
                                        <>
                                            {!this.state.noResults ? (
                                                <>
                                                    {renderItems}
                                                    <tr className="noBorderColor">
                                                        <td className="noBorderColor count" colSpan="9" >
                                                            <label className="textLabel">Count:</label> {this.state.candidates.length}
                                                        </td>
                                                    </tr>
                                                </>
                                            ) : (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <h5>No Results Found</h5>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }

    async GetActiveLeases(status) {
        this.setState({ loading: true, loadingDocument: false });
        const token = Session.getToken();
        const response = await fetch('api/Leases/ShowAllLeases?status=' + status, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        const data = await response.json();
        this.setState({ candidates: data, loading: false, noResults: data.length === 0 ? true : false });
    }

    //async GetReport(reportName) {
    //    this.setState({ loadingDocument: true });
    //    const token = Session.getToken();
    //    const response = await fetch('api/Leases/GetReport?reportName=' + reportName, {
    //        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    //    })
    //    const data = await response.json();
    //    this.setState({ loadingDocument: false });
    //    this.downloadFile(data.documentBase64, reportName);
    //}

    async GetReport(reportName) {
        try {
            this.setState({ loadingDocument: true });
            const token = Session.getToken();
            var search = {};
            if (this.state.searchOptions) {
                search = this.state.searchOptions;
            }


            search.reportName = reportName;
            if (!search.soffice_number) {
                search.soffice_number = null;
            };
            if (!search.s_type) {
                search.s_type = null;
            };
            if (!search.sbuilding_name) {
                search.sbuilding_name = null;
            };
            if (!search.saddress) {
                search.saddress = null;
            };
            if (!search.scity) {
                search.scity = null;
            };
            if (!search.sstate) {
                search.sstate = null;
            };
            if (!search.szip) {
                search.szip = null;
            };
            if (!search.sced) {
                search.sced = null;
            };
            if (!search.scede) {
                search.scede = null;
            };
            if (!search.sstatus) {
                search.sstatus = null;
            };

            console.log("Before string");
            var stringified = JSON.stringify(search);
            console.log("After string");
            console.log("String: " + stringified);
            const response = await fetch('api/Leases/GetReport', {
                method: 'POST',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify(search)
            });
            console.log("After response");
            const data = await response.json();
            console.log("After response.json");
            console.log("Response Json: " + data);
            this.setState({ loadingDocument: false });
            console.log("After loadingDocument");
            this.downloadFile(data.documentBase64, reportName);
        } catch (ex) {
            this.setState({ loadingDocument: false });
            console.log("Error: ");
            console.log(ex);
            throw ex;
        }
    }

    downloadFile(file, name) {
        const blob = this.base64ToBlob(file);
        const uriContent = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', uriContent);
        link.setAttribute('download', name);
        const event = new MouseEvent('click');
        link.dispatchEvent(event);
    }

    base64ToBlob = (file) => {
        const binaryString = window.atob(file);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; ++i) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        return blob;
    }

    async SearchLeases(searchOptions) {
        /*this.setState({ loading: true, loadingDocument: false });*/
        const token = Session.getToken();
        if (searchOptions.szip === "") {
            searchOptions.szip = null;
        }
        if (searchOptions.sstatus === "") {
            searchOptions.sstatus = null;
        }
        if (searchOptions.soffice_number === "") {
            searchOptions.soffice_number = null;
        }
        const response = await fetch('api/Leases/SearchLeases', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(searchOptions)
        });
        const data = await response.json();
        this.setState({ candidates: data, loading: false, noResults: data.length === 0 ? true : false });
        //const data = await response.json();
        //this.setState({ lease: data });
    }
}

